import { Action, DataContainer, Feature, submitEvent, submitEventMerge, submitMerge } from '@otto-ec/tracking-bct';

export class Tracking {
    private moin = '';
    private productId = '';
    private variationId = '';
    private eventMergeId?: string;

    public variationChanged(moin: string, productId: string, variationId: string, eventMergeId?: string) {
        this.moin = moin;
        this.productId = productId;
        this.variationId = variationId;
        this.eventMergeId = eventMergeId;
    }

    public trackView(dataContainer: DataContainer, features?: Feature[]) {
        if (this.eventMergeId) {
            submitEventMerge(this.eventMergeId, dataContainer, features ? { name: 'automatic', features } : undefined);
        } else {
            submitMerge(dataContainer, features);
        }
    }

    public trackEvent(dataContainer: DataContainer, action?: Action) {
        const features: Feature[] = [
            {
                id: this.productId,
                name: 'Product',
                status: 'visible',
            },
            {
                id: this.moin,
                labels: {},
                name: 'Business-Dimension',
                parentId: this.productId,
                position: 1,
                status: 'visible',
            },
            {
                id: this.variationId,
                labels: {},
                name: 'Variation',
                parentId: this.moin,
                position: 1,
                status: 'visible',
                variationId: this.variationId,
            },
        ];
        submitEvent(
            {
                ...dataContainer,
                product_VariationId: [this.variationId],
            },
            action
                ? {
                      ...action,
                      features: action.features.concat(features),
                  }
                : {
                      name: 'click',
                      features,
                  }
        );
    }
}
